// extracted by mini-css-extract-plugin
export default {"tooltip":"Zo-z","sharingV2":"_o-z","sharingIconsV2":"ap-z","links":"bp-z","link":"cp-z","facebookV2":"dp-z","twitterV2":"ep-z","pinterestV2":"fp-z"};